// src/config/consts/contact/index.ts
// 1. Informations de base
export const APP_NAME = 'Anton Yohan';
export const APP_TITLE = 'AntonYohan.com';
export const APP_DOMAIN = 'antonyohan.com';
export const APP_URL = `https://${APP_DOMAIN}/`;
export const APP_FOUNDER = 'Anton Yohan';

// 2. Adresse
export const APP_ADDRESS_STREET = '50 boulevard Testaniere';
export const APP_ADDRESS_LOCALITY = 'Marseille';
export const APP_ADDRESS_REGION = 'Bouches-du-Rhône';
export const APP_ADDRESS_POSTAL_CODE = '13010';
export const APP_ADDRESS_COUNTRY = 'FR';

export const APP_GEO_COORDINATES = {
  latitude: '43.5368448',
  longitude: '5.4463332',
};

// 3. Téléphone
export const APP_PHONE_PRIMARY = '+33 7 53 90 38 69';
export const APP_PHONE_SECONDARY = '+33 7 53 90 38 69';

// 4. Email
export const APP_EMAIL_PRIMARY = 'contact@antonyohan.com';
export const APP_EMAIL_SECONDARY = 'support@antonyohan.com';

// 6. Métadonnées supplémentaires
export const APP_CONTACT_ID = 'test-entreprise-12345';
export const APP_CONTACT_TYPE = 'Entreprise';
export const APP_ENTITY_TYPE = 'Freelancer'; // Freelancer, Entreprise, Organisation, etc.

export const APP_WORKING_HOURS = 'Mo-Su 08:00-23:00'; // Format lisible
export const APP_WORKING_HOURS_JSON = [
  { day: 'Lundi', start: '08:00', end: '23:00' },
  { day: 'Mardi', start: '08:00', end: '23:00' },
  { day: 'Mercredi', start: '08:00', end: '23:00' },
  { day: 'Jeudi', start: '08:00', end: '23:00' },
  { day: 'Vendredi', start: '08:00', end: '23:00' },
  { day: 'Samedi', start: '08:00', end: '23:00' },
  { day: 'Dimanche', start: '08:00', end: '23:00' },
];

export const APP_PAYMENT_METHODS = ['Espèces', 'Carte de Crédit', 'Virement Bancaire', 'Crypto (ETH, BTC, LTC)'];

export const APP_PROFILE_IMAGE = `${APP_URL}images/profile.jpg`;
export const APP_VAT_NUMBER = 'FR123456789'; // Numéro de TVA
export const APP_SIRET_NUMBER = '123 456 789 00012'; // Numéro SIRET
